<mat-toolbar>
    <button mat-icon-button (click)="emit()" matTooltip="Menu">
        <mat-icon>menu</mat-icon>
    </button>
    <img src="assets/CoverMyMeds_Logo_Screens.png" style="max-width: 50%; max-height: 50%; object-fit: contain;">
    <span class="spacer"></span>
    <button mat-icon-button matTooltip="My Account" [matMenuTriggerFor]="userAccountMenu">
        <mat-icon>account_circle</mat-icon>
    </button>
    <mat-label class="custom-size">Welcome {{userName}}</mat-label>
    <mat-menu #userAccountMenu [overlapTrigger]="false" yPosition="below">
        <button mat-menu-item routerLink="#">
            <mat-icon style="margin-right: 5px; margin-bottom: 3px">person</mat-icon>
            <mat-label class="custom-size">Your Profile</mat-label>
        </button>
        <button mat-menu-item routerLink="#">
            <mat-icon style="margin-right: 5px; margin-bottom: 3px">verified_user</mat-icon>
            <mat-label class="custom-size">Change Password</mat-label>
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item>
            <mat-icon style="margin-right: 5px; margin-bottom: 3px">exit_to_app</mat-icon>
            <mat-label class="custom-size" (click)="handleLogout()" >Sign out</mat-label>
        </button>
    </mat-menu>
</mat-toolbar>